// extracted by mini-css-extract-plugin
export var body = "_ka-0";
export var sectionHeader = "_ka-4";
export var shortcutColumns = "_ka-2";
export var shortcutList = "_ka-1";
export var shortcutSection = "_ka-3";